import { actionTypes } from '../actions';

const initialState = {
  activity: [],
  sortBy: 'date',
  searchTerm: '',
  page: 1,
  loading: false,
  total: 0,
};

export default (state = {...initialState}, action) => {
  switch (action.type) {

    case actionTypes.GET_USER_ACTIVITY_SUCCESS:
      return {
        ...state,
        activity: action.payload.results,
        loading: false,
        total: action.payload.total,
      };
    case actionTypes.GET_USER_ACTIVITY:
      return {
        ...state,
        loading: action.shouldBeReloaded,
      };
    case actionTypes.RESET_ACTIVITY_SEARCH_PARAMS:
      return {
        ...initialState,
      };
    case actionTypes.SET_ACTIVITY_SEARCH_PARAMS:
      const type = action.payload.type;
      const resetPage = type !== 'page' && state.page !== 1;
      return {
        ...state,
        page: resetPage ? 1 : state.page,
        [type]: action.payload.value,
      };
    case actionTypes.LOGGED_OFF:
        return {
          ...initialState
        };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./reducers/calls.js